module.exports = __webpack_public_path__ + "static/media/facebook.d819798b.svg";